import { Typography } from '@components/typography';
import { Stack, StackProps } from '@mui/material';
import { useField } from 'formik';
import { TextInput, TextInputProps } from '../TextInput';
import { FormFieldError } from './FormFieldError';

export type FormTextInputProps = Omit<TextInputProps, 'error'> & {
  fullwidth?: boolean;
  name: string;
  containerProps?: StackProps;
  inputContainerProps?: StackProps;
  helperText?: string;
  labelInfo?: string;
};

export const FormTextInput = ({
  maintainGutters = true,
  name,
  fullwidth = true,
  containerProps = {},
  inputContainerProps = {},
  helperText,
  labelInfo,
  ...props
}: FormTextInputProps) => {
  const [field, meta] = useField(name);
  const error = meta?.touched && meta?.error;
  return (
    <Stack sx={{ width: fullwidth ? '100%' : 'fit-content', ...containerProps.sx }}>
      <TextInput
        {...field}
        containerProps={{ ...inputContainerProps }}
        {...props}
        name={name}
        labelInfo={labelInfo}
        error={Boolean(error)}
      />
      {helperText && (
        <Typography variant="caption2" color="text.light" mt={0.5} ml={1}>
          {helperText}
        </Typography>
      )}
      <FormFieldError error={error} maintainGutters={maintainGutters} />
    </Stack>
  );
};
